import { render, staticRenderFns } from "./JobServiceSummary.vue?vue&type=template&id=98b2ea3e&scoped=true&"
import script from "./JobServiceSummary.vue?vue&type=script&lang=js&"
export * from "./JobServiceSummary.vue?vue&type=script&lang=js&"
import style0 from "./JobServiceSummary.vue?vue&type=style&index=0&id=98b2ea3e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98b2ea3e",
  null
  
)

export default component.exports